<template>
	<div class="al-kpi" data-tour="kpi">
		<v-row dense>
			<v-col v-for="t in tiles" :key="t.key" cols="6" md="3">
				<v-card outlined class="kpi-tile pa-3">
					<div class="kpi-label">
						<v-icon x-small :color="t.colore" class="mr-1">{{ t.icona }}</v-icon
						>{{ t.label }}
					</div>
					<div class="kpi-value">{{ t.value }}</div>
					<div class="kpi-hint">{{ t.hint }}</div>
				</v-card>
			</v-col>
		</v-row>

		<v-card outlined class="pa-3 mt-2" data-tour="top">
			<div class="kpi-label mb-2"><v-icon x-small class="mr-1">mdi-fire</v-icon>Prodotti più attesi</div>
			<div v-if="!top.length" class="kpi-hint">Nessun prodotto in attesa nel periodo.</div>
			<div v-for="(p, i) in top" :key="p._id || i" class="al-top">
				<span class="al-rank">{{ i + 1 }}</span>
				<div class="al-thumb">
					<img v-if="p.image" :src="p.image" alt="" loading="lazy" />
					<v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
				</div>
				<div class="al-name">
					<div class="al-full">{{ p.title || '—' }}</div>
					<div class="kpi-hint">{{ p.sku }}</div>
				</div>
				<v-chip x-small label color="orange darken-1" text-color="white">{{ p.count === 1 ? '1 richiesta' : p.count + ' richieste' }}</v-chip>
			</div>
		</v-card>
	</div>
</template>

<script>
// numeri in testa alla pagina Avvisi: richieste, invii, conversioni e prodotti più attesi
export default {
	name: 'AlertsKpi',
	props: {
		summary: { type: Object, default: null },
		// available | price: cambia solo le spiegazioni
		type: { type: String, default: 'available' },
	},
	computed: {
		s() {
			return this.summary || { waiting: 0, sent: 0, converted: 0, conversionRate: 0, topWaiting: [] };
		},
		tiles() {
			return [
				{
					key: 'waiting',
					label: 'In attesa',
					value: this.s.waiting,
					hint: this.type === 'price' ? 'clienti che aspettano un ribasso' : 'clienti che aspettano un prodotto',
					icona: 'mdi-timer-sand',
					colore: 'orange darken-1',
				},
				{
					key: 'sent',
					label: 'Avvisi inviati',
					value: this.s.sent,
					hint: this.type === 'price' ? 'il prezzo è sceso' : 'prodotto tornato disponibile',
					icona: 'mdi-email-check-outline',
					colore: 'primary',
				},
				{ key: 'converted', label: 'Convertiti', value: this.s.converted, hint: 'ordine entro 30 giorni dall’avviso', icona: 'mdi-cart-check', colore: 'green darken-1' },
				{
					key: 'rate',
					label: 'Conversione',
					value: `${String(this.s.conversionRate).replace('.', ',')}%`,
					hint: 'convertiti sugli avvisi inviati',
					icona: 'mdi-percent-outline',
					colore: 'green darken-1',
				},
			];
		},
		top() {
			return this.s.topWaiting || [];
		},
	},
};
</script>

<style scoped>
.kpi-label {
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: #5f6b7a;
}
.kpi-value {
	font-size: 1.6rem;
	font-weight: 600;
	color: #1f2d3d;
	line-height: 1.3;
}
.kpi-hint {
	font-size: 12px;
	color: #5f6b7a;
}
.al-top {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 6px 0;
	border-top: 1px solid #eef1f5;
}
.al-top:first-of-type {
	border-top: none;
}
.al-rank {
	width: 18px;
	text-align: center;
	font-weight: 600;
	color: #5f6b7a;
}
.al-thumb {
	width: 36px;
	height: 36px;
	flex: none;
	border-radius: 6px;
	background: #f2f4f8;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.al-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	background: #fff;
}
/* nome intero: la parte finale è la variante */
.al-full {
	white-space: normal;
	word-break: break-word;
}
.al-name {
	flex: 1;
	min-width: 0;
}
</style>
